import React from 'react';

const partners = [
  {
    name: 'Google Workspace',
    title: 'Google Workspace Solutions',
    type: 'google',
    logo: '/assets/images/partners/google-workspace-logo.svg',
    description:
      'Helping businesses adopt professional email, collaboration tools and a structured Google Workspace setup.',
    capabilities: ['Business email setup', 'Workspace onboarding', 'Collaboration support'],
    href: 'https://workspace.google.com/',
    status: 'Solutions Support',
  },
  {
    name: 'Razorpay',
    title: 'Razorpay Partner',
    type: 'razorpay',
    logo: '/assets/images/partners/razorpay-logo.svg',
    description:
      'Supporting secure payment gateway integration and onboarding workflows for websites, apps and digital products.',
    capabilities: ['Payment integration', 'Merchant onboarding', 'Checkout implementation'],
    href: 'https://rzp.io/rzp/CLhM3Mg',
    status: 'Partner',
  },
  {
    name: 'Fast2SMS',
    title: 'Fast2SMS Partner',
    type: 'fast2sms',
    logo: '/assets/images/partners/fast2sms-logo.png',
    description:
      'Supporting business messaging workflows with dependable SMS, OTP and communication API capabilities.',
    capabilities: ['SMS solutions', 'OTP workflows', 'API integration'],
    status: 'Partner',
  },
  {
    name: 'Shopify',
    title: 'Shopify Partner',
    type: 'shopify',
    logo: '/assets/images/partners/shopify-logo.svg',
    description:
      'Helping businesses create, customize and improve Shopify commerce experiences for streamlined online selling.',
    capabilities: ['Store setup', 'Theme customization', 'Commerce integration'],
    status: 'Partner',
  },
  {
    name: 'Meta',
    title: 'Meta Business Partner',
    type: 'meta',
    logo: '/assets/images/partners/meta-logo.png',
    description:
      'Supporting businesses with Meta platform solutions, campaign enablement and connected customer communication workflows.',
    capabilities: ['Meta solutions', 'Campaign support', 'Business messaging'],
    status: 'Partner',
  },
  {
    name: 'Ministry of Corporate Affairs',
    title: 'MCA Data Partner',
    type: 'mca',
    logo: '/assets/images/partners/mca-logo.svg',
    description:
      'Using MCA-sourced corporate information to support structured business data workflows and company information services.',
    capabilities: ['Corporate data', 'Company information', 'Data workflows'],
    status: 'Data Partner',
  },
];

const TechnologyPartners = () => (
  <section className="home-partners-section" aria-labelledby="home-partners-title">
    <div className="home-partners-pattern" aria-hidden="true"></div>
    <div className="auto-container">
      <div className="home-partners-heading">
        <div className="sec-title light">
          <div className="title">TRUSTED TECHNOLOGY ECOSYSTEM</div>
          <h2 id="home-partners-title">Our Technology Partnerships</h2>
        </div>
        <p>
          Technology relationships and implementation expertise that strengthen business
          productivity, communication, commerce and digital payment experiences.
        </p>
      </div>

      <div className="home-partners-grid">
        {partners.map((partner) => (
          <article className="home-partner-card" key={partner.name}>
            <div className={`home-partner-brand home-partner-brand--${partner.type}`}>
              <img
                src={partner.logo}
                alt={`${partner.name} logo`}
                className={`home-partner-logo home-partner-logo--${partner.type}`}
                loading="lazy"
              />
            </div>

            <div className="home-partner-content">
              <div className="home-partner-title-row">
                <h3>{partner.title}</h3>
                <span className="home-partner-status"><i className="fa fa-check-circle" aria-hidden="true"></i> {partner.status}</span>
              </div>
              <p>{partner.description}</p>
              <ul>
                {partner.capabilities.map((capability) => (
                  <li key={capability}><span className="fa fa-check" aria-hidden="true"></span>{capability}</li>
                ))}
              </ul>
              {partner.href && (
                <a href={partner.href} target="_blank" rel="noopener noreferrer nofollow" className="home-partner-link" aria-label={`Learn more about ${partner.name}`}>
                  {partner.type === 'razorpay' ? 'Get Started with Razorpay' : 'Explore Platform'} <span className="fa fa-external-link" aria-hidden="true"></span>
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default TechnologyPartners;
